<footer class="footer text-white">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-md-3">Footer</div>
    </div>
  </div>
</footer>
